import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_PRODUCT } from "../product.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateProductInput } from "../../../__generated__/globalTypes";
import {
  UpdateProductMutation,
  UpdateProductMutationVariables,
} from "../../../__generated__/UpdateProductMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateProduct = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateProductInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateProductMutation,
    UpdateProductMutationVariables
  >(UPDATE_PRODUCT, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateProduct?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateProduct?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
